import { error, finish } from '../../../modules/markets/actions/update-rule4';
import api from '../../../api';

export function request(dispatch, { eventId, marketId, ruleId, data }) {
    api.put(`/events/${eventId}/markets/${marketId}/rule4/${ruleId}`, data)
        .then(
            market => {
                market.selections = Object.keys(market.selections).map(x => market.selections[x]);

                dispatch(finish(marketId, ruleId, market));
            },
            errors => dispatch(error(marketId, ruleId, errors))
        );
}
